import React, { useMemo } from 'react';
/**@ldp-web/component-library imports */
import { BentoCardsContainerSkeleton } from '@ldp-web/component-library/ui/skeletons/bento-cards-container-skeleton';
import { NavTilesSkeleton } from '@ldp-web/component-library/ui/skeletons/nav-tiles-skeleton';
import { MiniProductTileCarouselSkeleton } from '@ldp-web/component-library/ui/skeletons/mini-product-tile-carousel-skeleton';
import { ProductCarouselSkeleton } from '@ldp-web/component-library/ui/skeletons/product-carousel-skeleton';
import { SpotlightSkeleton } from '@ldp-web/component-library/ui/skeletons/spotlight-skeleton';
import { MenuTileCarouselSkeleton } from '@ldp-web/component-library/ui/skeletons/menu-tile-carousel-skeleton';
import { SelectboxSkeleton } from '@ldp-web/component-library/ui/skeletons/selectbox-skeleton';
import { BreadcrumbsSkeleton } from '@ldp-web/component-library/ui/skeletons/breadcrumbs-skeleton';
import { QuickFiltersSkeleton } from '@ldp-web/component-library/ui/skeletons/quick-filters-skeleton';
import { ProductGridSkeleton } from '@ldp-web/component-library/ui/skeletons/product-grid-skeleton';
import { AccordionSkeleton } from '@ldp-web/component-library/ui/skeletons/accordion-skeleton';
import { FooterSkeleton } from '@ldp-web/component-library/ui/skeletons/footer-skeleton';
import { TableSkeleton } from '@ldp-web/component-library/ui/skeletons/table-skeleton';
import { HeroBannerSkeleton } from '@ldp-web/component-library/ui/skeletons/hero-banner-skeleton';
import { FormSkeleton } from '@ldp-web/component-library/ui/skeletons/form-skeleton';
import { ShoppableDisplaySkeleton } from '@ldp-web/component-library/ui/skeletons/shoppable-display-skeleton';
import { IabAdSkeleton } from '@ldp-web/component-library/ui/skeletons/iab-ad-skeleton';
import { WrapperSection } from '@ldp-web/component-library/ui/atoms/section';

/**
 * Hook to return the skeleton map
 */
export const useSkeletonMap = () => {
  return useMemo<Record<string, () => JSX.Element>>(
    () => ({
      heroComponent: () => <HeroBannerSkeleton />,
      stackedProductCarouselComponent: () => <MiniProductTileCarouselSkeleton />,
      productGridContainer: () => <ProductGridSkeleton />,
      productGridComponent: () => <ProductGridSkeleton />,
      productCarouselComponent: () => <ProductCarouselSkeleton />,
      brandSpotlightComponent: () => <SpotlightSkeleton />,
      bannerWithHeadlineComponent: () => <HeroBannerSkeleton />,
      menuTileCarouselComponent: () => <MenuTileCarouselSkeleton />,
      accordionComponent: () => <AccordionSkeleton />,
      breadcrumbsComponent: () => <BreadcrumbsSkeleton />,
      sortsComponent: () => <SelectboxSkeleton />,
      quickFiltersComponent: () => <QuickFiltersSkeleton />,
      filtersComponent: () => <QuickFiltersSkeleton />,
      sliderBannerComponent: () => <HeroBannerSkeleton />,
      verticalFeatureCardCarouselComponent: () => <NavTilesSkeleton />,
      horizontalFeatureCardCarouselComponent: () => <NavTilesSkeleton />,
      provinceListComponent: () => <SelectboxSkeleton />,
      longTextComponent: () => <SelectboxSkeleton />,
      navigationItemComponent: () => <AccordionSkeleton />,
      infoCardContainerComponent: () => <NavTilesSkeleton />,
      footerContentComponent: () => <FooterSkeleton />,
      acquisitionFormComponent: () => <FormSkeleton />,
      tableComponent: () => <TableSkeleton />,
      fireworkComponent: () => <NavTilesSkeleton />,
      bentoCardContainerComponent: () => <BentoCardsContainerSkeleton />,
      mediaIABComponent: () => (
        <WrapperSection>
          <IabAdSkeleton />
        </WrapperSection>
      ),
      mediaShoppableDisplayComponent: () => (
        <WrapperSection>
          <ShoppableDisplaySkeleton />
        </WrapperSection>
      ),
    }),
    []
  );
};

export default useSkeletonMap;
